import React from 'react';
import ReactDOM from 'react-dom';


import './backDrop.css'


const Backdrop = (props) => {
    return ReactDOM.createPortal(
        <div className='backdrop' onClick={props.onClick}></div>,
        document.getElementById('backdrop-hook')
    )
}
export default Backdrop;